<template>
    <div class="data-evaluation-page">
        <!-- 企业信息 -->
        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <span>企业信息</span>
            </div>
            <el-table :data="enterpriseInfoData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        {{ scope.row.value }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 数据资产信息 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据资产信息</span>
            </div>
            <el-table :data="dataAssetInfoData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        {{ scope.row.value }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 数据详情 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据详情</span>
            </div>
            <el-table :data="dataDetailData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        <span v-if="scope.row.label === '冷数据处理方式'"> {{ scope.row.value }}</span>
                        <div v-else class="file-list">
                            <div v-for="(item, index) in getFileList(scope.row.value)" :key="index" class="file-item">
                                {{ item }}

                                <el-button v-if="isPreviewable(item)" type="text" size="mini" @click="previewFile(item)"
                                    style="margin-left: 8px;">
                                    预览
                                </el-button>
                                <el-button type="text" size="small" @click="downloadFile(scope.row.value)">
                                    下载
                                </el-button>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 质量审核结果 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>质量评价结果</span>
            </div>
            <el-table :data="qualityResultData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        <div v-if="scope.row.label === '数据质量评估报告'" class="report-actions">
                            {{ scope.row.value }}
                            <el-button v-if="isPreviewable(scope.row.value)" type="text" size="small"
                                @click="previewFile(scope.row.value)" :loading="isPreviewLoading">
                                预览
                            </el-button>
                            <el-button type="text" size="small" @click="downloadFile(scope.row.value)">
                                下载
                            </el-button>
                        </div>
                        <div v-else>
                            {{ scope.row.value }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <div style="margin-top: 30px; text-align: center;">
            <el-button type="danger" size="medium" @click="close('/DataQualityManager')" style="width: 80px;">
                关闭
            </el-button>
        </div>

        <!-- 文件预览组件 -->
        <file-preview ref="filePreview" download-base-url="/web/dataQuality/download" />
    </div>
</template>

<script>
import FilePreview from '@/components/FilePreview.vue';

export default {
    name: 'DataQualityDetailManager',
    components: {
        FilePreview
    },
    data() {
        return {
            registrationId: '',
            dataQualityInfoData: null,
            enterpriseInfoData: [],
            dataAssetInfoData: [],
            dataDetailData: [],
            qualityResultData: [],
            isPreviewLoading: false
        }
    },
    created() {
        // 从路由中获取传递的参数
        this.registrationId = this.$route.query.registrationId || '';

        if (this.registrationId) {
            this.initializeApplication();
        }
    },
    methods: {
        initializeApplication() {
            this.getRequest(`/web/dataQualityDetail/query?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data && resp.data.object) {
                        console.log(resp.data.object);

                        this.dataQualityInfoData = resp.data.object;

                        // 数据详情
                        this.dataDetailData = [
                            { label: '字段信息', value: this.dataQualityInfoData.dataFieldFile },
                            { label: '数据资产相关数据表', value: this.dataQualityInfoData.dataDetailedFile },
                            { label: '冷数据处理方式', value: this.dataQualityInfoData.oldDataHandle }
                        ];

                        // 审核结果
                        this.qualityResultData = [
                            { label: '存在问题', value: this.dataQualityInfoData.existingIssues },
                            { label: '审核意见', value: this.dataQualityInfoData.evaluation },
                            { label: '数据质量评估得分', value: this.dataQualityInfoData.dataQualityScore },
                            {
                                label: '数据质量评估报告',
                                value: this.dataQualityInfoData.evaluationReport
                            }
                        ];
                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
            // 获取企业信息
            this.getRequest(`/web/companyInfo/queryByRegistrationId?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data) {
                        this.enterpriseInfoData = [
                            { label: '企业名称', value: resp.data.companyName },
                            { label: '统一社会信用代码', value: resp.data.socialCreditCode },
                            { label: '经营范围', value: resp.data.businessNature },
                            { label: '联系人姓名', value: resp.data.contactsName },
                            { label: '联系电话', value: resp.data.contactsPhone }
                        ];
                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
            // 查询数据资产信息
            this.getRequest(`/web/dataAssets/queryByRegistrationId?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data) {
                        this.dataAssetInfoData = [
                            { label: '数据资产名称', value: resp.data.assetName },
                            { label: '数据来源', value: resp.data.dataSource },
                            { label: '所属行业', value: resp.data.industry },
                            { label: '更新周期', value: resp.data.updateCycle },
                            { label: '数据覆盖地域', value: resp.data.region },
                            { label: '应用场景描述', value: resp.data.scenario },
                            { label: '数据资产简介', value: resp.data.description }
                        ];
                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
        },

        // 获取文件列表（处理字符串或数组）
        getFileList(fileValue) {
            if (!fileValue) return [];

            if (Array.isArray(fileValue)) {
                return fileValue;
            }

            if (typeof fileValue === 'string') {
                // 如果是逗号分隔的文件名，分割成数组
                return fileValue.split(',').map(item => item.trim()).filter(item => item);
            }

            return [fileValue];
        },

        // 判断文件是否可预览
        isPreviewable(fileName) {
            if (!fileName) return false;

            // 确保fileName是字符串
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) return false;

            const ext = this.getFileExtension(fileNameStr);
            const previewableTypes = [
                'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', // 图片
                'pdf', // PDF
                'xls', 'xlsx', 'csv', // Excel文件
                'doc', 'docx', // Word文档
                'txt', 'json', 'xml', 'csv', 'log', 'js', 'css', 'html', 'md' // 文本文件
            ];
            return previewableTypes.includes(ext);
        },

        // 获取文件扩展名
        getFileExtension(filename) {
            if (!filename) return '';
            const parts = String(filename).split('.');
            return parts.length > 1 ? parts.pop().toLowerCase() : '';
        },

        // 下载文件
        async downloadFile(fileName) {
            try {
                const fileNameStr = String(fileName).trim();
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/dataQuality/download?registrationId=' + this.registrationId + '&fileName=' + encodeURIComponent(fileNameStr),
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileNameStr);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                this.$message.success('文件下载开始');
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + (error.message || ''));
            }
        },

        // 预览文件
        async previewFile(fileName) {
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) {
                this.$message.warning('文件名不能为空');
                return;
            }

            this.isPreviewLoading = true;
            try {
                await this.$refs.filePreview.openPreview(
                    { fileName: fileNameStr },
                    this.registrationId
                );
            } catch (error) {
                console.error('预览失败:', error);
                this.$message.error('文件预览失败: ' + (error.message || ''));
            } finally {
                this.isPreviewLoading = false;
            }
        },

        close(targetPage = '/home') {
            const fullPath = this.$route.fullPath;
            const currentPath = this.$route.path;

            // 1. 先跳转到指定页面
            if (currentPath !== targetPage) {
                this.$router.push(targetPage).then(() => {
                    // 2. 跳转成功后延迟关闭当前标签页
                    setTimeout(() => {
                        this.closeTab(fullPath);
                    }, 100);
                }).catch(() => {
                    // 跳转失败时仍然尝试关闭
                    this.closeTab(fullPath);
                });
            } else {
                // 如果已经在目标页面，直接关闭
                this.closeTab(fullPath);
            }
        },

        // 提取关闭标签页的公共方法
        closeTab(fullPath) {
            this.$emit('close-tab', fullPath);

            let parent = this.$parent;
            while (parent) {
                if (typeof parent.removeTab === 'function') {
                    parent.removeTab(fullPath);
                    break;
                }
                parent = parent.$parent;
            }
        },
    }
}
</script>

<style scoped>
.data-evaluation-page {
    padding: 15px;
    background-color: #f5f5f5;
}

.box-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.box-card>>>.el-card__header {
    background-color: #f0f0f0;
    font-weight: bold;
    font-size: 16px;
    color: #333;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-form-item {
    margin-bottom: 10px;
}

.el-form-item>>>.el-form-item__label {
    color: #666;
    font-weight: normal;
}

.file-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.file-item {
    display: flex;
    align-items: center;
}

.report-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}
</style>